import { useMutation, useQueryClient } from '@tanstack/react-query';
import { contractApi } from '@/features/contracts/api/contractApi';

/**
 * Récapitulatif du report du 1er prélèvement (dry-run).
 * Déclenché à l'ouverture de la modale via .mutate() — pas un useQuery pour
 * éviter un fetch automatique et un cache inutile.
 */
export const useFirstChargePostponePreview = (contractId: number | undefined) =>
  useMutation({
    mutationFn: () => {
      if (!contractId) throw new Error('contractId requis');
      return contractApi.postponeFirstCharge(contractId, true);
    },
  });

/**
 * Exécute le report : abonnement reporté, prélèvement remboursé, commission rendue.
 * Invalide les paiements, les remboursements et la timeline d'audit du contrat.
 */
export const useConfirmFirstChargePostpone = (contractId: number | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => {
      if (!contractId) throw new Error('contractId requis');
      return contractApi.postponeFirstCharge(contractId, false);
    },
    onSuccess: () => {
      if (!contractId) return;
      queryClient.invalidateQueries({ queryKey: ['payment-details', contractId] });
      queryClient.invalidateQueries({ queryKey: ['contract-refunds', contractId] });
      queryClient.invalidateQueries({ queryKey: ['contract-audit-logs', contractId] });
    },
  });
};
